import React, {useEffect} from "react";
import { observer } from "mobx-react-lite";
import { Form, Input, Row, Col, Button, Modal } from "antd";
import { useStore } from "../../../app/stores/store";
import PropTypes from "prop-types";
import { useEmployeeSalary } from "../../../app/hooks/useEmployeeSalary";
import { toast } from "react-toastify";

const AdjustSalaryModalForm = ({ record }) => {
  AdjustSalaryModalForm.propTypes = {
    record: PropTypes.object.isRequired,
  };

  const [form] = Form.useForm();
  const { salaryStore, payrollStore } = useStore();
  const {
    isAdjustModal,
    salaryAdjustmentFormData,
    personalInfoFormData,
    setIsAdjustModal,
    setGetSalaryEmployeeId,
    setSalaryAdjustmentFormData,
    fetchEmployeeSalary
  } = salaryStore;

  const {setIsAdjustBtn} = payrollStore

  const {  update, mutate } = useEmployeeSalary();

  useEffect(() => {
    if (salaryAdjustmentFormData) {
      form.setFieldsValue({
        previousSalary: salaryAdjustmentFormData?.amount,
        newSalary: salaryAdjustmentFormData?.adjustedAmount,
      });
    }
  }, [salaryAdjustmentFormData, form]);
  

  const handleCancel = () => {
    setIsAdjustModal(false);
    setIsAdjustBtn(false)
  };

  const handleSubmit = async (values) => {
    try {
      const salaryAdjustmentObj = {
        serviceRecordId: personalInfoFormData?.serviceRecords[0]?.employmentSalary?.serviceRecordId,
        employeeId: salaryAdjustmentFormData?.employeeId,
        employeeNumber: salaryAdjustmentFormData?.employeeNumber,
        employeeName: salaryAdjustmentFormData?.employeeName,
        position: personalInfoFormData?.serviceRecords[0]?.positionName,
        previousSalary: Number(values.previousSalary),
        newSalary: Number(values.newSalary),
      };
      await update(salaryAdjustmentObj)
        .then(() => {
          setIsAdjustModal(false);
          setIsAdjustBtn(false);
          fetchEmployeeSalary();
          mutate();
          form.resetFields();
          toast.success("Successfully Update Employee Salary", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            // Extract error titles and display them in toasts
            error.response.data.errors.forEach((errorItem) => {
              toast.error(errorItem.title, {
                position: toast.POSITION.TOP_RIGHT,
              });
            });
          } else {
            // Display a generic error message
            toast.error("An error occurred. Please try again.", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Button
        style={{
          backgroundColor: "red",
          borderColor: "red",
          color: "#fff",
        }}
        onClick={() => {
          setIsAdjustModal(true);
          setSalaryAdjustmentFormData(record?.employeeId);
          setGetSalaryEmployeeId(record?.employeeId);
        }}
      >
        Adjust
      </Button>
      <Modal
        open={isAdjustModal}
        footer={null}
        width={800}
        onCancel={handleCancel}
        destroyOnClose
        mask={false}
      >
        <Form  onFinish={handleSubmit} form={form}>
          <Row>
            <Col style={{ flex: 1, textAlign: "center" }}>
              <h1>
                SALARY <span style={{ color: "#FF7201" }}>ADJUSTMENT</span>
              </h1>
            </Col>
          </Row>
          <Row gutter={10} justify="space-between" align="middle">
            <Col>
              <Form.Item
                name="previousSalary"
                label="Current Salary"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input disabled={true}/>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="newSalary"
                label="Adjusted Salary"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Row gutter={20} justify={"center"}>
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    backgroundColor: "#F47F20",
                    borderRadius: "83px",
                    width: "123.87px",
                  }}
                >
                  Save
                </Button>
              </Col>
              {/* <Col>
                <Button
                  type="default"
                  onClick={handleBack}
                  style={{
                    backgroundColor: "#2C2C2C",
                    borderRadius: "83px",
                    width: "123.87px",
                    color: "#ffff",
                  }}
                >
                  Cancel
                </Button>
              </Col> */}
            </Row>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default observer(AdjustSalaryModalForm);
